import { FactoryUtils } from "@/utils/FactoryUtils"
import { statisticsConfig } from '@/utils/statisticsConfig'


export const config =  {
    'monthly':{
        toastInfo: () => {return FactoryUtils.monthly()},
        toastTitle:'月缴',
        toastStatic:() =>{statisticsConfig.insur_paymonthinfo_click()},
    },
    'service':{
        toastInfo: () => {return FactoryUtils.service()},
        toastTitle:'服务详情',
        toastStatic:() =>{statisticsConfig.insur_prodetail_click()},
    }
}